import React, { useState, useEffect } from 'react';
import './DocumentTable.css';
import DocumentModel from './DocumentModel';
import apiService from '../api/apiService';
import 'react-toastify/dist/ReactToastify.css';
import Pagination from './Pagination/Pagination';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import { toast } from 'react-toastify';

const DocumentTable = ({ data, setData, guests, hotelId }) => {
  const [editingItem, setEditingItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [menuVisible, setMenuVisible] = useState(null);
  //const [guests, setGuests] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState({
    isOpen: false,
    id: null,
  });

  const confirmDelete = id => {
    if (!id) return;
    setDeleteConfirm({ isOpen: true, id });
  };

  /* useEffect(() => {
    const fetchGuests = async () => {
      try {
        const res = await apiService.get('/guests/');
        setGuests(res);
      } catch (error) {
        console.error('Failed to fetch guests:', error);
        setGuests([]);
      }
    };
    fetchGuests();
  }, []); */

  const handleEditClick = item => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  const handleEdit = updatedItem => {
    setData(prevData =>
      prevData.map(item => (item.id === updatedItem.id ? updatedItem : item))
    );
    setIsModalOpen(false);
    setEditingItem(null);
  };

  const handleDelete = async () => {
    try {
      await apiService.delete(
        `/documents/${deleteConfirm.id}/?hotel=${hotelId}`
      );
      setData(prevData =>
        prevData.filter(item => item.id !== deleteConfirm.id)
      );
      toast.error('Document deleted successfully');
    } catch (err) {
      toast.error('Failed to delete document');
    } finally {
      setDeleteConfirm({ isOpen: false, id: null });
      setMenuVisible(null);
    }
  };

  /* const toggleMenu = id => {
    setMenuVisible(menuVisible === id ? null : id);
  }; */

  const getGuestName = guestId => {
    const guest = guests.find(g => g.id === guestId);
    return guest
      ? guest.name || `${guest.first_name} ${guest.last_name}`
      : 'Unknown Guest';
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = Array.isArray(data)
    ? data.slice(indexOfFirstRow, indexOfLastRow)
    : [];
  const totalPages = Math.max(Math.ceil(data.length / rowsPerPage), 1);

  return (
    <>
      <div className="document-table-container" style={{ minHeight: '300px' }}>
        <table className="document-table">
          <thead>
            <tr>
              <th>Guest</th>
              <th>Document Type</th>
              <th>Description</th>
              <th>File</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map(item => (
                <tr key={item.id}>
                  <td>{getGuestName(item.guest)}</td>
                  <td>{item.doc_type}</td>
                  <td>{item.description}</td>
                  <td>{item.file ? item.file.split('/').pop() : 'No file'}</td>

                  <td>
                    <div className="options-menu">
                      <button className="options-button">⋮</button>
                      <div className="dropdown-menu">
                        <button onClick={() => handleEditClick(item)}>
                          Edit
                        </button>
                        <button onClick={() => confirmDelete(item.id)}>
                          Delete
                        </button>
                        {item.file && (
                          <>
                            <button
                              onClick={() => window.open(item.file, '_blank')}
                            >
                              View
                            </button>
                            {/* Download Button */}
                            <button
                              onClick={async () => {
                                try {
                                  const response = await fetch(item.file);
                                  const blob = await response.blob();
                                  const url = window.URL.createObjectURL(blob);
                                  const link = document.createElement('a');
                                  link.href = url;
                                  link.download = item.file.split('/').pop();
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  window.URL.revokeObjectURL(url); // Cleanup blob URL
                                } catch (error) {
                                  console.error('Download failed', error);
                                }
                              }}
                            >
                              Download
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No documents available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div>
        {isModalOpen && (
          <DocumentModel
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSave={handleEdit}
            existingData={editingItem}
            hotelId={hotelId}
            guests={guests}
          />
        )}

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>

      <ConfirmDeleteModal
        isOpen={deleteConfirm.isOpen}
        onConfirm={handleDelete}
        onCancel={() => setDeleteConfirm({ isOpen: false, id: null })}
        message="Are you sure you want to delete this document?"
      />
    </>
  );
};

export default DocumentTable;
